/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum PoiType {
    Parking = 'parking',
    FuelStation = 'fuelStation',
    Firm = 'firm',
    OurFirm = 'ourFirm',
    InstallationService = 'installationService'
}

export function PoiTypeFromJSON(json: any): PoiType {
    return PoiTypeFromJSONTyped(json, false);
}

export function PoiTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiType {
    return json as PoiType;
}

export function PoiTypeToJSON(value?: PoiType | null): any {
    return value as any;
}

